module.exports = __webpack_public_path__ + "img/0Q3A2496_P_L_Wood_MockedUp.3f4bd42d.jpg";